export const BAAS_CORE_I18N = {
    GENERIC_ERROR: 'Er heeft zich een fout voorgedaan',
    INSUFFICIENT_PRIVILEGES_FOR_ACTIE:
        'Onvoldoende rechten voor actie "{{actie}}" (includeVoorWie: {{includeVoorwie}} - includeHoedanigheid: {{includeHoedanigheid}})',
    ZONES_NOT_ALLOWED: 'Geen toegang voor zone(s): "{{zones}}"'
} as const;
